import $ from "../../libs/jquery-3.3.1.min.js"
import {AudioPlaylist} from '/js/app/base/AudioPlaylist.js'
import {gsap} from "../../libs/gsap/all.js"
import {Howl} from "howler";

export class Video {

  // Constructor
  constructor() {
    this.currentVideo = null;
    this.$currentScreenEl = null
  }

  /**
   * Start video and set variable
   * @param $screenElement
   * @param callback
   */
  startVideo($screenElement, callback) {
    this.$currentScreenEl = $screenElement;
    let $video = this.$currentScreenEl.find(`.media-container video.${app.i18n.lang}`).eq(0);
    $video = $video.length ? $video : this.$currentScreenEl.find("video").eq(0);

    if ($video.length) {
      this.currentVideo = $video.get(0);
      this.currentVideo.currentTime = 0;

      $video.off("ended").one("ended", () => this.videoEnded());
      this.currentVideo.play();
    } else {
      console.log("A video wasn't found in " + this.$currentScreenEl.attr("id"));
    }

    // Callback function
    if (callback !== undefined && typeof callback === "function") {
      callback();
    }
  }

  /**
   * End currently playing video and reset variable
   * ScreenId is not needed, just stop the current video
   * @param callback
   */
  stopVideo(callback) {
    // Pause, reset video
    if (this.currentVideo) {
      this.currentVideo.pause();
      this.currentVideo.currentTime = 0;
      $(this.currentVideo).off("ended");
    }

    // Callback function
    if (callback !== undefined && typeof callback === "function") {
      callback();
    } else if (callback === "goToNextScreen") {
      app.goToNextScreen();
    }
  }

  videoEnded() {
    this.$currentScreenEl.find(".replay-overlay").fadeIn();
  }

  replayVideo() {
    this.$currentScreenEl.find(".replay-overlay").fadeOut(() => {
      this.startVideo(this.$currentScreenEl);
    });
  }

  /**
   * Reset function
   */
  reset() {
    this.stopVideo();
    if (this.$currentScreenEl) {
      this.$currentScreenEl.find(".replay-overlay").hide();
      this.$currentScreenEl = null
    }
    this.currentVideo = null;
  }
}
